<template>
  <div
    class="holder"
    :style="{
      borderTop: borderStyle,
      height: holderSize,
      width: holderSize,
    }"
  >
    <div
      class="dot"
      :style="{ background: dotStyle }"
    />
  </div>
</template>
<script>
export default {
  name: 'CustomLoading',
  props: {
    size: { type: [String, Number], default: 25 },
    color: { type: String, default: '#00a19a' },
    dotColor: { type: String, default: '#00a19a' },
  },
  computed: {
    holderSize() {
      return `${this.size}px`
    },
    borderStyle() {
      return `2px solid ${this.color}`
    },
    dotStyle() {
      return this.dotColor
    },
  },
}
</script>
<style scoped>
@import './index.scss';
</style>
